const menu = {
    label: '• Instrumentos',
    to: '/sol/instrumentos',
    rules: ['SOL-001'],
};

export default menu;
